import * as React from 'react';
import cn from 'classnames';
const { Dropdown } = require('@cvent/carina-dropdown');
const { SearchIcon } = require('@cvent/carina-icon');

import { Search } from '@weddingspot/ws-api-client';

const _styles = require('./MarketLinksContainer.scss');

interface MarketLinksContainerProps {
    marketLinks: Search.RelativeUrl[];
}

const remapMarketLinks = (marketLinks: Search.RelativeUrl[]) => {
    return marketLinks.map((link) => ({ label: link.label, value: link.url }));
};

export const MarketLinksContainer = (props: MarketLinksContainerProps) => {
    const marketLinks = props.marketLinks;

    const handleUpdate = (value: string) => {
        window.location.href = value;
    };

    return (
        <div className={_styles.className}>
            <div className={_styles.input}>
                <Dropdown
                    options={remapMarketLinks(marketLinks)}
                    hasError={false}
                    disabled={false}
                    onUpdate={handleUpdate}
                    placeholder='Locations'
                />
            </div>
        </div>
    );
};
